import { Injectable, computed, signal } from '@angular/core';

export type RbacPortalScope = 'platform' | 'tenant';

@Injectable({ providedIn: 'root' })
export class RbacPortalScopeService {
  /** Super Admin portal (4200) vs Tenant Admin portal (4201) — two separate RBAC catalogs. */
  readonly scope = signal<RbacPortalScope>('platform');

  readonly isPlatform = computed(() => this.scope() === 'platform');
  readonly isTenant = computed(() => this.scope() === 'tenant');
  readonly isReady = computed(() => true);

  setScope(scope: RbacPortalScope): void {
    this.scope.set(scope);
  }

  roleApiPrefix(): string {
    return this.isPlatform() ? '/role' : '/admin-portal/rbac/role';
  }

  permissionApiPrefix(): string {
    return this.isPlatform() ? '/permission' : '/admin-portal/rbac/permission';
  }

  scopeLabel(): string {
    return this.isPlatform()
      ? 'Super Admin portal'
      : 'Tenant Admin portal';
  }
}
